import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';

/**
 * Fluid placeholder for the standalone jö card.
 *
 * Kept in its own module so it can be rendered as a Suspense fallback without pulling in the
 * disconnected body.
 */
export const JoeOverviewCardSkeleton = () => (
  <Skeleton className="min-h-20_5 w-full" data-testid="joe-overview-loading" />
);
